import React, { Component } from 'react';
import { Panel } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/pro-solid-svg-icons';

import ChecklistSection from './checklist_section';

export default class Checklist extends Component {
  static propTypes = {
    projectTypeLabel: PropTypes.string.isRequired,
    sections: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      listingType: PropTypes.string.isRequired,
      projectStatus: PropTypes.string.isRequired,
      relation: PropTypes.string
    })).isRequired,
    showChecklistItemModal: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired
  };

  state = {
    expanded: false
  }

  toggleExpanded = () => {
    this.setState((prevState) => {
      return { expanded: !prevState.expanded };
    });
  }

  renderSection = (section) => {
    return (
      <ChecklistSection
        key={`${section.listingType}-${section.projectStatus}`}
        listingType={section.listingType}
        projectStatus={section.projectStatus}
        projectTypeLabel={this.props.projectTypeLabel}
        relation={section.relation}
        showChecklistItemModal={this.props.showChecklistItemModal}
        statusLabel={section.label}
      />
    );
  }

  renderBody() {
    if (!this.state.expanded) return;

    return (
      <Panel.Body>
        {this.props.sections.map(this.renderSection)}
      </Panel.Body>
    );
  }

  render() {
    return (
      <Panel>
        <Panel.Heading className='clickable' name='checklist-toggle' onClick={this.toggleExpanded}>
          <div className='row-eq-height'>
            <div className='grow'>
              <h4 className='panel-title'>
                {this.props.title}
              </h4>
            </div>
            <div>
              <FontAwesomeIcon icon={this.state.expanded ? faChevronUp : faChevronDown} />
            </div>
          </div>
        </Panel.Heading>
        {this.renderBody()}
      </Panel>
    );
  }
}
